<template>
	<nav
		:class="[
			'container__menuoptionsnaigation',
			{ 'container__menuoptionsnaigation--active': isMenuHamburguerActive },
		]"
	>
		<ul class="container__menuoptionsnaigation__menu">
			<li
				v-for="(menuOption, key) in menuOptions"
				:key="key"
				class="container__menuoptionsnaigation__menu__options"
			>
				<a
					:style="`opacity: ${menuOption.soon || menuOption.upgrade ? 0.5 : 1}`"
					style="display: flex; gap: 0.5rem; align-items: center"
					:class="[
						'container__menuoptionsnaigation__menu__options__item',
						{
							'container__menuoptionsnaigation__menu__options__item--active':
								menuOption.subMenuActive,
						},
					]"
					:title="menuOption.menuItem"
					@click="changeSubmenuActive(menuOption, menuOption.subMenuActive)"
				>
					{{ menuOption.menuItem }}
					<p
						v-if="menuOption.soon"
						style="
							margin: 0;
							background-color: var(--color-green);
							color: white;
							padding: 0 0.5rem;
							font-size: 9px;
							height: fit-content;
							border-radius: 5px;
						"
					>
						{{ $t('comingSoon') }}
					</p>
					<p
						v-if="menuOption.upgrade"
						style="
							text-transform: capitalize;
							margin: 0;
							background-color: var(--color-green);
							color: white;
							padding: 0 0.5rem;
							font-size: 9px;
							height: fit-content;
							border-radius: 5px;
						"
					>
						{{ $t('upgrade') }}
					</p>
				</a>
				<ul
					:class="[
						'container__menuoptionsnaigation__menu__options__submenu',
						{
							'container__menuoptionsnaigation__menu__options__submenu--active':
								menuOption.subMenuActive,
						},
					]"
				>
					<li
						v-for="(subItem, key) in menuOption.subItens"
						:key="key"
						class="container__menuoptionsnaigation__menu__options__submenu__list"
					>
						<a
							:class="
								subItem.upgrade
									? 'container__menuoptionsnaigation__menu__options__submenu__list_item__upgrade'
									: 'container__menuoptionsnaigation__menu__options__submenu__list_item'
							"
							@click="changeRoute(subItem)"
							>{{ subItem.name }}
							<span
								v-if="subItem.isNew"
								class="badge-new"
							>
								NEW
							</span>
							<Icon
								v-if="subItem.upgrade"
								icon="material-symbols:lock"
								style="color: var(--color-green)"
							/>
						</a>
					</li>
				</ul>
			</li>
		</ul>
	</nav>
</template>

<script>
import { Icon } from '@iconify/vue2'
export default {
	components: {
		Icon,
	},
	props: {
		menuOptions: Array,
		isMenuHamburguerActive: Boolean,
		cleanActiveSubmenuActive: Function,
		changeMenuHamburguerActive: Function,
	},
	methods: {
		/**
		 * Deixa apenas o ultimo submenu clicado ativo
		 */
		changeSubmenuActive(menuOption, isActive) {
			if (window.innerWidth < 992) {
				this.cleanActiveSubmenuActive(menuOption)
				menuOption.subMenuActive = !isActive
			}
		},
		/**
		 * Muda a rota atual do usuario quando clicado no menu
		 */
		changeRoute(subItem) {
			if (subItem.link) {
				const isAlreadyInRoute = this.$route.matched.some(
					(m) => m.path.substring(1) === subItem.link,
				)
				if (!isAlreadyInRoute) {
					this.$router.push({ name: subItem.link })
					if (this.isMenuHamburguerActive) {
						this.changeMenuHamburguerActive()
					}
				}
			} else if (subItem.external) {
				window.open(subItem.external, '_blank').focus()
			} else subItem.action()
		},
	},
}
</script>

<style scoped>
.container__menuoptionsnaigation {
	position: absolute;
	height: 100vh;
	width: 80vw;
	max-width: 18rem;
	background-color: white;
	padding-left: 1rem;
	top: 2.5rem;
	left: -18rem;
	transition: left 0.5s ease-in-out;
	z-index: 100;
	font-size: 0.75rem;
	user-select: none;
}

.container__menuoptionsnaigation--active {
	left: 0;
}

.container__menuoptionsnaigation__menu__options {
	display: flex;
	flex-direction: column;
	margin-top: 1rem;
	width: 100%;
}

.container__menuoptionsnaigation__menu__options__item {
	width: 100%;
	list-style-type: none;
	color: var(--color-gray);
	cursor: pointer;
	transition: all 0.2s ease-in-out;
}

.container__menuoptionsnaigation__menu__options__item:hover,
.container__menuoptionsnaigation__menu__options__item--active {
	color: var(--color-navy-blue);
	/* font-weight: 700; */
}

.container__menuoptionsnaigation__menu__options__submenu {
	height: 0;
	width: 0;
	padding: 0 !important;
	overflow: hidden;
	top: auto;
}

.container__menuoptionsnaigation__menu__options__submenu--active {
	height: auto;
	width: auto;
}

.container__menuoptionsnaigation__menu__options__submenu__list {
	display: flex;
	flex-direction: row;
}

.container__menuoptionsnaigation__menu__options__submenu__list_item {
	display: flex;
	font-weight: 300;
	color: var(--color-navy-blue);
	cursor: pointer;
	width: 100%;
	padding: 0.1rem 1rem;
}

.container__menuoptionsnaigation__menu__options__submenu__list_item:hover {
	font-weight: 500;
	background-color: var(--color-navy-blue);
	color: white;
}

.container__menuoptionsnaigation__menu__options__submenu__list_item__upgrade {
	opacity: 0.7;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	font-weight: 300;
	color: var(--color-navy-blue);
	cursor: not-allowed;
	width: 100%;
	padding: 0.1rem 1rem;
}

.badge-new {
	margin-left: 0.5rem;
	background-color: var(--color-green);
	color: white;
	padding: 0.15rem 0.5rem;
	font-size: 8px;
	font-weight: 700;
	border-radius: 8px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	box-shadow: 0 2px 4px rgba(0, 128, 0, 0.3);
	animation: pulse-badge 2s ease-in-out infinite;
}

@keyframes pulse-badge {
	0%,
	100% {
		transform: scale(1);
		box-shadow: 0 2px 4px rgba(0, 128, 0, 0.3);
	}
	50% {
		transform: scale(1.05);
		box-shadow: 0 3px 8px rgba(0, 128, 0, 0.5);
	}
}

@media screen and (min-width: 992px) {
	.container__menuoptionsnaigation {
		position: static;
		height: fit-content;
		width: 100%;
		max-width: unset;
		padding: 0;
	}

	.container__menuoptionsnaigation__menu {
		height: fit-content;
		padding-left: 12px;
		margin: 0;
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
	}

	.container__menuoptionsnaigation__menu__options {
		display: flex;
		align-items: center;
		vertical-align: middle;
		width: auto;
		padding: 0 0.55rem;
		margin: 0;
		height: fit-content;
		flex: 0 0 auto;
	}

	.container__menuoptionsnaigation__menu__options__item {
		width: auto;
		white-space: nowrap;
	}

	/* .container__menuoptionsnaigation__menu__options__item::before {
    display: block;
    content: attr(title);
    font-weight: 700;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  } */
	.container__menuoptionsnaigation__menu__options:hover
		.container__menuoptionsnaigation__menu__options__submenu,
	.container__menuoptionsnaigation__menu__options__submenu:hover {
		position: absolute;
		top: 2.5rem;
		background-color: white;
		height: auto;
		width: auto;
		z-index: 10;
		box-shadow: 0px 17px 34px -10px rgba(0, 0, 0, 0.35);
		top: auto;
	}

	.container__menuoptionsnaigation__menu__options__submenu__list_item {
		background-color: var(--color-light-blue);
	}

	.container__menuoptionsnaigation__menu__options__submenu__list_item__upgrade {
		background-color: #f1f5f8dd;
	}
}
</style>
